/* eslint-disable */
// @ts-nocheck
import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../../main/support/dash_api';
import NotificationActions from '../../main/actions/NotificationActions';
import type { Windows } from '../../main/types/attributionWindowTypes';
import type { Org } from '../types/orgTypes';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
const ORG_ENDPOINT = '/v1/org';
const ORG_SETTINGS_FIELDS = ['name', 'timezone'];
const errorProvider = new ErrorProvider();
export const ORG_INITIALIZED = 'ORG_INITIALIZED';
export function orgInitializationComplete() {
  return function (dispatch: (arg0: {}) => void) {
    return dispatch({
      type: ORG_INITIALIZED,
    });
  };
}
const FetchAppsAndOrgs = new ReduxAsyncAction('FETCH_APPS_AND_ORGS');
FetchAppsAndOrgs.registerRequest(function () {
  return dash_api.get(`${ORG_ENDPOINT}/fetch-all`).then(({ data: appsAndOrgs }) => {
    return {
      appsAndOrgs,
    };
  });
});
export const fetchAppsAndOrgs = FetchAppsAndOrgs.request;
export const FETCH_APPS_AND_ORGS = FetchAppsAndOrgs.constants;
const FetchCurrentOrg = new ReduxAsyncAction('FETCH_CURRENT_ORG');
FetchCurrentOrg.registerRequest(function () {
  return dash_api.get(`${ORG_ENDPOINT}`).then(({ data: org }) => {
    return {
      org,
    };
  });
});
export const fetchCurrentOrg = FetchCurrentOrg.request;
export const FETCH_CURRENT_ORG = FetchCurrentOrg.constants;
const SaveOrgAttributionWindows = new ReduxAsyncAction('SAVE_ORG_ATTRIBUTION_WINDOWS');
SaveOrgAttributionWindows.registerRequest(
  (windows: Windows, apps: Array<string> | null | undefined, resetAllApps: boolean | null | undefined) => {
    NotificationActions.entitySaving();
    return dash_api
      .post(`${ORG_ENDPOINT}/attribution-windows`, {
        windows,
        apps,
        resetAllApps,
      })
      .then(({ data: org }) => {
        NotificationActions.entitySaved(org);
        return org;
      })
      .catch((err) => {
        console.error('Error saving org attribution windows: ', err);
        NotificationActions.entityError(
          errorProvider.parse(err).getFieldEmpty() || errorProvider.parse(err).getFieldEmpty()
        );
      });
  }
);
export const saveOrgAttributionWindows = SaveOrgAttributionWindows.request;
export const SAVE_ORG_ATTRIBUTION_WINDOWS = SaveOrgAttributionWindows.constants;
const SaveOrgSettings = new ReduxAsyncAction('SAVE_ORG_SETTINGS');
SaveOrgSettings.registerRequest((orgData: Org) => {
  NotificationActions.entitySaving();
  const settingsToSave = ORG_SETTINGS_FIELDS.reduce((acc = {}, key) => {
    if (orgData.hasOwnProperty(key)) {
      acc[key] = orgData[key];
    }

    return acc;
  }, {});
  return dash_api
    .patch(`${ORG_ENDPOINT}`, settingsToSave)
    .then(({ data: org }) => {
      NotificationActions.entitySaved(org);
      return org;
    })
    .catch((err) => {
      console.error('Error saving organization settings: ', errorProvider.parse(err).getResponse());
      NotificationActions.entityError(
        errorProvider.parse(err).getFieldEmpty() ||
          'Failed to save organization settings, please check that fields are valid'
      );
    });
});
export const saveOrgSettings = SaveOrgSettings.request;
export const SAVE_ORG_SETTINGS = SaveOrgSettings.constants;
